import { get, isNil } from "lodash";

const ENTITY_READ_PREFIX = {
  contact: "contact",
  user: "contact.user",
  contract: "contract",
};

/** Read a flushed entity value using the field-registry target (mirrors API). */
export const resolveByTarget = (project, target) => {
  if (!target || !target.entity || !target.property) return undefined;
  const { entity, property } = target;
  if (entity === "telecom") {
    const key = target.filter || "system";
    const telecom = (get(project, "contact.telecoms") || []).find(
      (entry) => get(entry, key) === target.filterValue,
    );
    return get(telecom, property);
  }
  if (entity === "project") {
    if (String(property).indexOf("fields.") === 0) {
      return get(project, `fields.${String(property).slice(7)}`);
    }
    return get(project, property);
  }
  if (entity === "contact" && String(property).indexOf("fields.") === 0) {
    return get(project, `contact.fields.${String(property).slice(7)}`);
  }
  const prefix = ENTITY_READ_PREFIX[entity];
  return get(
    project,
    prefix ? `${prefix}.${property}` : `${entity}.${property}`,
  );
};

const draftStorageKey = (target) => {
  if (!target || !target.entity || !target.property) return null;
  return target.filterValue
    ? `${target.entity}.${target.property}.${target.filterValue}`
    : `${target.entity}.${target.property}`;
};

/**
 * Resolve a canvas form field value from project / draft buffer / status data.
 * Friendly accessors like `telecom.zipCode` do not exist as project paths —
 * they map onto contact.telecoms (or contact.user, etc.) via registry targets.
 */
export const resolveFormFieldValue = ({
  project,
  data = {},
  accessor,
  meta,
}) => {
  if (!accessor) return undefined;

  if (!isNil(meta && meta.target)) {
    const fromTarget = resolveByTarget(project, meta.target);
    if (!isNil(fromTarget)) return fromTarget;
  }

  let value = get(project, accessor);

  if (isNil(value) && String(accessor).indexOf("custom.") === 0) {
    value = get(project, `fields.${String(accessor).slice("custom.".length)}`);
  }

  if (isNil(value) && meta && meta.target) {
    const draftKey = draftStorageKey(meta.target);
    if (draftKey) value = get(project, ["fields", draftKey]);
  }

  if (isNil(value)) value = get(data, accessor);

  return value;
};
